import { useState, ChangeEvent } from 'react'
import { useForm } from 'react-hook-form'
import { IFormInputs } from './Mapas.interface'

export const useMapas = () => {
  const [adminId, setAdminId] = useState('not-admin')
  const [isLoading, setIsLoading] = useState(false)
  const [estados, setEstados] = useState<string[]>([])

  const [searchCNAE, setSearchCNAE] = useState('')
  const [searchPredicoes, setSearchPredicoes] = useState('')
  const [searchProspects, setSearchProspects] = useState('')
  const [searchDistancia, setSearchDistancia] = useState('')

  const { register, control, setValue, watch } = useForm<IFormInputs>({
    mode: 'onChange',
    defaultValues: {
      isAdmin: false,
    },
  })

  const statusLabel = watch('isActive') ? 'Inativo' : 'Ativo'

  const accessList: { [key: string]: string } = {
    dashboard: 'Dashboard',
    prediction: 'Predições',
    products: 'Produtos',
    sellers: 'Vendedores',
    companies: 'Empresas',
    sheets: 'Importar Planilha',
    users: 'Usuários e Permissões',
  }

  const emailValidation = {
    required: true,
    pattern: /^[^@ ]+@[^@ ]+\.[^@ .]{2,}$/,
  }

  const handleGetId = ({ target: { id } }: ChangeEvent<HTMLInputElement>) => {
    setAdminId(() => id || '')
    setValue('isAdmin', id === 'admin')
  }

  return {
    adminId,
    accessList,
    control,
    emailValidation,
    handleGetId,
    register,
    statusLabel,
    isLoading,
    setIsLoading,
    estados,
    setEstados,

    searchCNAE,
    setSearchCNAE,
    searchPredicoes,
    setSearchPredicoes,
    searchProspects,
    setSearchProspects,
    searchDistancia,
    setSearchDistancia,
  }
}
